import { z } from "zod";
import type { PublicConfig } from "../types";

const errorShape = z.object({
  message: z.string().optional(),
  error: z.string().optional()
}).passthrough();

export class ApiError extends Error {
  constructor(message: string, public status: number) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData) && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }
  const response = await fetch(path, {
    ...init,
    headers,
    credentials: "include"
  });
  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("json") ? await response.json() : await response.text();
  if (!response.ok) {
    const parsed = errorShape.safeParse(payload);
    const message = parsed.success
      ? parsed.data.message || parsed.data.error || `Request failed (${response.status})`
      : String(payload || `Request failed (${response.status})`);
    throw new ApiError(message, response.status);
  }
  return payload as T;
}

export function getPublicConfig() {
  return api<PublicConfig>("/api/config");
}

export function postJson<T>(path: string, body: unknown) {
  return api<T>(path, { method: "POST", body: JSON.stringify(body) });
}

export function patchJson<T>(path: string, body: unknown) {
  return api<T>(path, { method: "PATCH", body: JSON.stringify(body) });
}
